export default function PageContentContainer({
  children,
  className = '',
  style = {},
  contentClassName = '',
}) {
  return (
    <div
      style={style}
      className={`${className} w-full flex justify-center`}
    >
      <div
        className={`${contentClassName} w-full lg:w-[95%] grid:max-w-[1440px]`}
      >
        {children}
      </div>
    </div>
  );
}
